import { Users, Trophy, ListChecks, FileBadge, Wrench, Medal, Search, FileSpreadsheet } from "lucide-react";
import Layout from "../components/Layout";
import DashboardCard from "../components/DashboardCard";
import { useAuth } from "../context/AuthContext";

export default function AdminDashboard() {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.25em] text-blue-700 font-bold">Pannello Amministratore</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-2">
          Benvenuto, {user?.name?.split(" ")[0] || "Admin"}
        </h1>
        <p className="text-slate-500 mt-3 max-w-2xl">
          Gestisci utenti giudici, competizioni, risultati in tempo reale e certificati.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <DashboardCard
          title="Gestione Utenti Giudici"
          description="Crea e gestisci le utenze dei giudici e responsabili abilitati alla valutazione."
          icon={Users}
          to="/admin/utenti"
          accent="blue"
          testId="admin-card-utenti"
          delay={0}
        />
        <DashboardCard
          title="Gestione Competizioni"
          description="Crea nuove competizioni e assegnale a un Responsabile dell'evento."
          icon={Trophy}
          to="/admin/competizioni"
          accent="amber"
          testId="admin-card-competizioni"
          delay={80}
        />
        <DashboardCard
          title="Gestione Risultati"
          description="Visualizza in tempo reale i risultati per evento, ordinati alfabeticamente."
          icon={ListChecks}
          to="/admin/risultati"
          accent="emerald"
          testId="admin-card-risultati"
          delay={160}
        />
        <DashboardCard
          title="Gestione Certificati"
          description="Emetti i certificati con i risultati ottenuti dagli atleti."
          icon={FileBadge}
          to="/admin/certificati"
          accent="rose"
          testId="admin-card-certificati"
          delay={240}
        />
      </div>

      {/* TOOLS ADMIN section */}
      <div className="mt-14 bg-white rounded-3xl ring-1 ring-slate-200 p-6 sm:p-8" data-testid="tools-admin-section">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-xl bg-indigo-50 text-indigo-700 flex items-center justify-center">
            <Wrench className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-indigo-700 font-bold">Tools Admin</p>
            <h2 className="font-display text-2xl font-semibold text-slate-900 mt-1">Strumenti avanzati</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <DashboardCard
            title="Classifica/Ranking"
            description="Classifica degli atleti ordinata per Totale Generale per ogni competizione."
            icon={Medal}
            to="/admin/tools/classifica"
            accent="amber"
            testId="tool-card-classifica"
            delay={0}
          />
          <DashboardCard
            title="Filtri & Ricerca"
            description="Cerca e filtra le competizioni per nome, luogo o data."
            icon={Search}
            to="/admin/tools/ricerca"
            accent="blue"
            testId="tool-card-ricerca"
            delay={80}
          />
          <DashboardCard
            title="Export CSV / Excel"
            description="Esporta i risultati di una competizione in formato CSV o Excel."
            icon={FileSpreadsheet}
            to="/admin/tools/export"
            accent="emerald"
            testId="tool-card-export"
            delay={160}
          />
        </div>
      </div>
    </Layout>
  );
}
